import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, map, of } from 'rxjs';
import httpConfig from '../helpers/http-config';

@Injectable({
  providedIn: 'root'
})
export class SmsService {

  constructor(private http: HttpClient) { }

  verifyPhoneNumber(phoneNumber: string) {
    const url = `${environment.APP_API_URL}/api/v1/Sms/verify/{phoneNumber}`
      .replace(`{${"phoneNumber"}}`, encodeURIComponent(String(phoneNumber)));
    return this.http.post(url, httpConfig())
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          console.error(error);
          return of([]);
        })
      );
  }

  validateVerificationCode(verificationCode: string) {
    const url: string = `${environment.APP_API_URL}/api/v1/Sms/validate/{verificationCode}`
      .replace(`{${"verificationCode"}}`, encodeURIComponent(String(verificationCode)));
    return this.http.post(url, httpConfig())
    .pipe(
      map((response: boolean | any) => {
        return response;
      }),
      catchError(error => {
        console.error(error);
        return of([]);
      })
    )
  }

  lockoutSms(){
    let url: string = `${environment.APP_API_URL}/api/v1/Sms/lockout`;

    return this.http.post(url, httpConfig())
    .pipe(
      map((response) => (response as any)),
      catchError(error => {
        console.error(error);
        return of([]);
      })
    )
  }

  sendStartSuccessMessage() {
    let url: string = `${environment.APP_API_URL}/api/v1/Sms/started`;

    return this.http.post(url, httpConfig())
    .pipe(
      map((response) => (response as any)),
      catchError(error => {
        console.error(error);
        return of([]);
      })
    )
  }
}